/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type HpRespLayout_viewer$ref = any;
export type homepageRootQueryVariables = {
    readonly hasRecentlyViewedItems: boolean;
    readonly isMobile: boolean;
    readonly homepageId: string;
    readonly userId: string;
    readonly hasUserId: boolean;
    readonly isTrade: boolean;
    readonly recentlyViewedItemIds?: ReadonlyArray<string | null> | null;
    readonly isClient: boolean;
};
export type homepageRootQueryResponse = {
    readonly viewer: {
        readonly informationalContent?: {
            readonly visible: boolean | null;
        } | null;
        readonly homepage: {
            readonly metadata: {
                readonly title: string | null;
                readonly description: string | null;
            } | null;
        } | null;
        readonly " $fragmentRefs": HpRespLayout_viewer$ref;
    } | null;
};
export type homepageRootQuery = {
    readonly response: homepageRootQueryResponse;
    readonly variables: homepageRootQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "hasRecentlyViewedItems",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isMobile",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "homepageId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "recentlyViewedItemIds",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isClient",
            "type": "Boolean!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "rootId",
            "variableName": "homepageId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "metadata",
        "storageKey": null,
        "args": null,
        "concreteType": "HomepageMetadata",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            (v3 /*: any*/)
        ]
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "visible",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cmsId",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "link",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "imageUrl",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contemporaryTrackingString",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isLinkable",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "PromoItem",
        "plural": true,
        "selections": [
            (v7 /*: any*/),
            (v8 /*: any*/),
            (v11 /*: any*/),
            {
                "kind": "Condition",
                "passingValue": false,
                "condition": "isMobile",
                "selections": [
                    (v9 /*: any*/)
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isMobile",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "mobileImageUrl",
                        "args": null,
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "cta",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "items",
        "storageKey": null,
        "args": null,
        "concreteType": "Product",
        "plural": true,
        "selections": [
            (v7 /*: any*/),
            (v2 /*: any*/),
            (v8 /*: any*/),
            (v9 /*: any*/)
        ]
    } as any), v15 = ({
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "seller",
        "storageKey": null,
        "args": null,
        "concreteType": "Seller",
        "plural": false,
        "selections": [
            (v16 /*: any*/),
            (v17 /*: any*/)
        ]
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "pricing",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPricing",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "retailPrice",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    (v19 /*: any*/)
                ]
            }
        ]
    } as any), v21 = [
        ({
            "kind": "Literal",
            "name": "limit",
            "value": 1
        } as any)
    ], v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "masterOrZoomPath",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedPdpUrl",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustomizable",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isMultiSku",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "vertical",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayPrice",
        "storageKey": "displayPrice(isTrade:false,page:\"searchAndBrowse\")",
        "args": [
            {
                "kind": "Literal",
                "name": "isTrade",
                "value": false
            },
            {
                "kind": "Literal",
                "name": "page",
                "value": "searchAndBrowse"
            }
        ],
        "concreteType": "ItemDisplayPriceType",
        "plural": true,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "convertedAmountList",
                "storageKey": null,
                "args": null,
                "concreteType": "ConvertedAmountList",
                "plural": true,
                "selections": [
                    (v19 /*: any*/),
                    (v27 /*: any*/)
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantityDisplay",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "percentageOff",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "type",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceLabel",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceVariability",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v29 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "lowestShipmentQuote",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "complimentaryShipping",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "totalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedAmountList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "plural": true,
                        "selections": [
                            (v27 /*: any*/),
                            (v19 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "serviceMethod",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentServiceMethod",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                    },
                    (v17 /*: any*/)
                ]
            },
            (v17 /*: any*/)
        ]
    } as any), v30 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "classification",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemClassification",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "creationDate",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v32 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "creators",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCreator",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "attribution",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creator",
                "storageKey": null,
                "args": null,
                "concreteType": "Creator",
                "plural": false,
                "selections": [
                    (v31 /*: any*/),
                    (v17 /*: any*/)
                ]
            },
            (v17 /*: any*/)
        ]
    } as any), v33 = ({
        "kind": "LinkedField",
        "alias": "productPhotos",
        "name": "photos",
        "storageKey": "photos(limit:1)",
        "args": (v21 /*: any*/),
        "concreteType": "ItemPhoto",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "placeholder",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "smallPath",
                "args": null,
                "storageKey": null
            },
            (v22 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "versions",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPhotoVersion",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "webPath",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            (v17 /*: any*/)
        ]
    } as any), v34 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v35 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "quickViewDisplay",
        "storageKey": null,
        "args": null,
        "concreteType": "QuickViewDisplayType",
        "plural": false,
        "selections": [
            (v2 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": "mobileTitle",
                "name": "title",
                "args": (v34 /*: any*/),
                "storageKey": "title(formatType:\"MOBILE\")"
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "paragraphs",
                "storageKey": null,
                "args": null,
                "concreteType": "QuickViewParagraph",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "key",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "text",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": "mobileText",
                        "name": "text",
                        "args": (v34 /*: any*/),
                        "storageKey": "text(formatType:\"MOBILE\")"
                    }
                ]
            }
        ]
    } as any), v36 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "browseUrl",
        "args": null,
        "storageKey": null
    } as any), v37 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryCode",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "homepageRootQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "homepage",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Homepage",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/)
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "HpRespLayout_viewer",
                            "args": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "isTrade",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "informationalContent",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "InformationalContentType",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "homepageRootQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": "showNewHomepageLocationsModule",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "showNewHomepageLocationsModule"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"showNewHomepageLocationsModule\")"
                        },
                        {
                            "kind": "ScalarField",
                            "alias": "isDiscoverPageDisabled",
                            "name": "isEnabledByLocale",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "featureName",
                                    "value": "DISABLE_DISCOVERY_PAGE"
                                }
                            ],
                            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_DISCOVERY_PAGE\")"
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "homepage",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "Homepage",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heroModuleOld",
                                    "name": "module",
                                    "storageKey": "module(type:\"hero\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "hero"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "HeroModule",
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "items",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Product",
                                                    "plural": true,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v10 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "promoPrimaryModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"promoPrimary\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "promoPrimary"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "PromoModule",
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v12 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "totalItemsCount",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "collectionsModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"collections\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "collections"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "CollectionsModule",
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "items",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Product",
                                                    "plural": true,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v11 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "featuredModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"featured\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "featured"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "FeaturedModule",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "primaryItem",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FeaturedItem",
                                                    "plural": false,
                                                    "selections": [
                                                        (v13 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "items",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FeaturedItem",
                                                    "plural": true,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/),
                                                        (v2 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "promoSecondaryModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"promoSecondary\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "promoSecondary"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "PromoModule",
                                            "selections": [
                                                (v12 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "editorialModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"editorial\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "editorial"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "EditorialModule",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "items",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "EditorialItem",
                                                    "plural": true,
                                                    "selections": [
                                                        (v7 /*: any*/),
                                                        (v13 /*: any*/),
                                                        (v3 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v9 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "shopByModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"shopBy\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "shopBy"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "ShopByModule",
                                            "selections": [
                                                (v2 /*: any*/),
                                                (v14 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "locationsModule",
                                    "name": "module",
                                    "storageKey": "module(type:\"locations\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "type",
                                            "value": "locations"
                                        }
                                    ],
                                    "concreteType": null,
                                    "plural": false,
                                    "selections": [
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "type": "LocationsModule",
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "subtitle",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "location",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Location",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v9 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "items",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "LocationItem",
                                                            "plural": true,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v2 /*: any*/),
                                                                (v8 /*: any*/),
                                                                (v11 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v14 /*: any*/)
                                            ]
                                        }
                                    ]
                                },
                                (v4 /*: any*/),
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "hasUserId",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "personalization",
                                            "storageKey": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 3
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "numItems",
                                                    "value": 3
                                                },
                                                (v15 /*: any*/)
                                            ],
                                            "concreteType": "PersonalizationModuleConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PersonalizationModuleEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "PersonalizationModule",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "url",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "categoryTitle",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "variant",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "categoryMainItem",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Item",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v16 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "photos",
                                                                            "storageKey": "photos(limit:1)",
                                                                            "args": (v21 /*: any*/),
                                                                            "concreteType": "ItemPhoto",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v22 /*: any*/),
                                                                                (v17 /*: any*/)
                                                                            ]
                                                                        },
                                                                        (v17 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "categoryItems",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Item",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v23 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v18 /*: any*/),
                                                                        (v20 /*: any*/),
                                                                        (v24 /*: any*/),
                                                                        (v25 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        (v26 /*: any*/),
                                                                        (v28 /*: any*/),
                                                                        (v29 /*: any*/),
                                                                        (v30 /*: any*/),
                                                                        (v32 /*: any*/),
                                                                        (v33 /*: any*/),
                                                                        (v35 /*: any*/),
                                                                        (v17 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        (v17 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "isClient",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "regionalInfo",
                                    "storageKey": "regionalInfo(regionTypes:\"ITEM_LOCATION\")",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "regionTypes",
                                            "value": "ITEM_LOCATION"
                                        }
                                    ],
                                    "concreteType": "RegionalInfo",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "regionsByZipCode",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RegionsByZipCode",
                                            "plural": true,
                                            "selections": [
                                                (v31 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "urlLabel",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "weight",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "locationPageExists",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        (v17 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "isTrade",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "informationalContent",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "InformationalContentType",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v2 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "benefits",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "ctaText",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "ctaUrl",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "ctaTitle",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": [
                                        (v15 /*: any*/)
                                    ],
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "recentHistoryList",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RecentHistoryItem",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "eventDate",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "item",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "firstPhotoWebPath",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "size",
                                                                    "value": "small"
                                                                }
                                                            ],
                                                            "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pdpURL",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v16 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "categoryPath",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v18 /*: any*/),
                                                        (v17 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        (v17 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasRecentlyViewedItems",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "items",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "itemIds",
                                            "variableName": "recentlyViewedItemIds"
                                        }
                                    ],
                                    "concreteType": "ItemsConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemsEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Item",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        (v2 /*: any*/),
                                                        (v36 /*: any*/),
                                                        (v37 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v26 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        (v30 /*: any*/),
                                                        (v32 /*: any*/),
                                                        (v33 /*: any*/),
                                                        (v35 /*: any*/),
                                                        (v17 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "homepageRootQuery",
            "id": "app-buyer-misc/232.0.0-2019-09-10T19:33:45.097Z/homepageRootQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '7a01ad0d1cdcfd7e45d5a5232edc1b70';
export default node;
